import Vue, { PropType } from 'vue';




export enum Grayout {
  None = '',
  Half = 'half',
  Full = 'gray',
};

export default Vue.extend({

  name: 'UserStamp',

  props: {
    stamp: {
      type: String,
      required: true,
    },
    grayout: {
      type: String as PropType<Grayout>,
      default: Grayout.None,
    },
  },

  computed: {
    stampName(): string {
      switch (this.grayout) {
        case Grayout.None: return this.stamp;
        case Grayout.Half: return `${this.stamp}_${this.grayout}`;
        case Grayout.Full: return this.grayout;
        default:           return this.grayout;
      }
    },
  },

});
